import { camelCase } from "lodash";

import { positionableUtil } from "@stormwater-software/common";
import { positionableDataApis } from "./api";
import assetTypeUtil from "./assetTypeUtil";

/**
 * Positionable utils defined in this app (vs. the shared `@stormwater-software/common` lib),
 * keyed by the camelCased positionable type.
 */
const localPositionableUtils = {
  assetType: assetTypeUtil,
};

/**
 * {utils/positionable} provides positionableUtil and exports commonly used functions
 */

const cachedApiNames = {}; // { [positionableType: string]: string }

export const getApiPrefix = positionableType => {
  if (!cachedApiNames[positionableType]) {
    cachedApiNames[positionableType] = camelCase(positionableType);
  }

  return cachedApiNames[positionableType];
};

export const getUtil = positionableType => {
  const prefix = getApiPrefix(positionableType);

  if (localPositionableUtils[prefix]) {
    return localPositionableUtils[prefix];
  }

  if (positionableUtil[prefix]) {
    return positionableUtil[prefix];
  }

  throw new Error(
    `Positionable Type (${positionableType}) does not have {positionableUtil} implementation (${getApiPrefix(
      positionableType,
    )})`,
  );
};

export const attachLocalUtils = mapContext => {
  if (!mapContext) {
    return;
  }

  mapContext.getUtil = positionableType => {
    const prefix = getApiPrefix(positionableType);

    return localPositionableUtils[prefix] || positionableUtil[prefix];
  };
};

/**
 * Get the api (XHR) for the specified positionable type
 */
export const getApi = positionableType => {
  const apiName = `${getApiPrefix(positionableType)}Api`;

  if (positionableDataApis[apiName]) {
    return positionableDataApis[apiName];
  }

  throw new Error(
    `Positionable Type (${positionableType}) does not have {api} implementation (${apiName})`,
  );
};

export const getIcon = (positionableType, sourceModel) =>
  getUtil(positionableType).getIcon(sourceModel);

export const getName = (positionableType, sourceModel) =>
  getUtil(positionableType).getName(sourceModel);
